import { useState } from "react";
import { Button, Box, IconButton, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";
import { useParams } from 'react-router-dom';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import useApiManager from '../../../../utils/Api/apiManager';
import ConfirmationDialog from "../../../ConfirmationDialog/ConfirmationDialog";


const AttachmentItemActions = ({ attachment, handleLinkClick, fetchLeadAttachments }) => {
    const { leadId } = useParams();
    const [openDialog, setOpenDialog] = useState(false);
    const { del } = useApiManager();

    const handleOpenDialog = () => {
        setOpenDialog(true);
    };

    const handleCloseDialog = () => {
        setOpenDialog(false);
    };

    const handleLink = () => {
        handleLinkClick(attachment);
    };

    const handleDelete = async () => {
        const url = `/leads/${leadId}/attachments/${attachment.id}`;

        try {
            await del(url);
            fetchLeadAttachments();
        } catch (error) {
            console.error('Error deleting note:', error);
            // Handle error (e.g., show error message)
        } finally {
            handleCloseDialog(); // Close the dialog after deletion
        }
    }

    return (
        <Box
        >
            {attachment.type == 2 && <IconButton onClick={handleLink}><EditIcon fontSize="small" /></IconButton>}
            <IconButton onClick={handleOpenDialog}><DeleteIcon fontSize="small" /></IconButton>
            <ConfirmationDialog
                open={openDialog}
                title="Confirm Action"
                content="Are you sure you want to delete this item?"
                onClose={handleCloseDialog}
                onConfirm={handleDelete}
                confirmText="Confirm"
                cancelText="Cancel"
            />
        </Box>

    );
}

export default AttachmentItemActions;
